// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"828":"9706ba99","939":"9c18e56a","986":"01f754cc"}[chunkId] + ".css";
};